import PreLoader from "@wevo/react-components/lib/PreLoader";
import _get from "lodash/get";
import { denormalize } from "normalizr";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import {
    isLoaded,
    isLoading,
    shouldLoadOnMount
} from "../../modules/asyncHttpAction";
import {
    getDriverQuotes,
    getDriversForPage,
    getSelectedDriver
} from "../../modules/drivers";
import { pageSchema } from "../../schemas";
import styles from "../../styles/components/Drivers.css";
import ScrollLockDiv from "../ScrollLockDiv";
import DriverQuotes from "./DriverQuotes";
import DriverSelect from "./DriverSelect";
import PageDriversGraph from "./PageDriversGraph";

const MIN_RESPONDENTS_TO_SHOW_DRIVER_SCORES = 120;

function NoDataMessage() {
    return (
        <p className={styles.noDataMessage}>
            No driver data found for this page
        </p>
    );
}

function DriverContent({ page, driverQuotes, wevo }) {
    const pageImage = _get(page, ["image", "files", "original"]);
    const numRespondents = wevo.numTargetedRespondentsPerPage;
    const showDriverScores =
        numRespondents >= MIN_RESPONDENTS_TO_SHOW_DRIVER_SCORES;

    return (
        <div>
            {showDriverScores && (
                <div className={styles.resultsContentRow}>
                    <div className={styles.resultsContentRowCell}>
                        <h3
                            className={styles.driverSectionHeading}
                            title={page.name}
                        >
                            {page.name}
                        </h3>
                        <div className={styles.driverPageImage}>
                            <ScrollLockDiv
                                className={styles.pageImageContainer}
                            >
                                <img
                                    className={styles.pageImage}
                                    src={pageImage.imageUrl}
                                />
                            </ScrollLockDiv>
                        </div>
                    </div>
                    <div className={styles.resultsContentRowCell}>
                        <h3
                            className={styles.driverSectionHeading}
                            title="Driver Scores"
                        >
                            Driver Scores
                        </h3>
                        <PageDriversGraph pageId={page.id} />
                    </div>
                </div>
            )}
            <DriverSelect />
            <div className={styles.resultsContentRow}>
                <DriverQuotes driverQuotes={driverQuotes} wevo={wevo} />
            </div>
        </div>
    );
}

class Drivers extends React.Component {
    componentWillMount() {
        if (
            !this.props.drivers ||
            shouldLoadOnMount(this.props.pageResultRequest)
        ) {
            this.props.fetchPageResults(this.props.pageId);
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.drivers && prevProps.pageId !== this.props.pageId) {
            this.props.fetchPageResults(this.props.pageId);
        }
    }

    render() {
        const { drivers, pageResultRequest } = this.props;
        return (
            <div className={styles.chapter}>
                <header className={styles.chapterHeader}>
                    <h2 className={styles.chapterTitle}>Drivers</h2>
                    <p className={styles.chapterSubtitle}>
                        See how your page scored on the five WEVO conversion
                        drivers.
                    </p>
                </header>
                <div>
                    {isLoading(pageResultRequest) && <PreLoader />}
                    {isLoaded(pageResultRequest) &&
                        drivers &&
                        drivers.length === 0 && <NoDataMessage />}
                    {isLoaded(pageResultRequest) &&
                        drivers &&
                        drivers.length > 0 && (
                            <DriverContent
                                page={this.props.page}
                                driverQuotes={this.props.driverQuotes}
                                wevo={this.props.wevo}
                            />
                        )}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const { pageResultRequest } = state.results;

    const { pageId } = props;
    const page = denormalize(pageId, pageSchema, state.api) || null;
    const drivers = getDriversForPage(state, props);
    const driverQuotes = getDriverQuotes(state, props);
    const selectedDriver = getSelectedDriver(state, props);

    return {
        page,
        pageResultRequest,
        drivers,
        driverQuotes,
        selectedDriver
    };
}

Drivers.propTypes = {
    pageId: PropTypes.number.isRequired,
    fetchPageResults: PropTypes.func.isRequired,
    wevo: PropTypes.object.isRequired
};

export default connect(
    mapStateToProps,
    null
)(Drivers);



// WEBPACK FOOTER //
// ./src/components/Results/Drivers.js